import { Image } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const CardMessageEmptyStateWrapper = styled.div(
  ({ giftWrapperUrl }) => css`
    background: url(${giftWrapperUrl});
    background-size: 100%;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    display: grid;
    flex: 1;
    flex-direction: column;
    grid-template-columns: 2fr;
    height: calc(100% - 42px);
    margin: 43px auto 0;
    padding-top: 100px;
    position: relative;
    width: 100%;
  `
);

const CardMessageWrapper = styled.div(
  ({ giftWrapperUrl }) => css`
    background: url(${giftWrapperUrl});
    background-size: 100%;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    display: flex;
    flex-direction: column;
    height: calc(100% - 42px);
    justify-content: center;
    margin: 43px auto 0;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
    width: 100%;
  `
);

const ExperienceBowImage = styled(Image)`
  grid-column-start: 1;
  grid-row-start: 1;
  margin: 0px auto;
  width: 100%;
`;

const ExperienceCardImage = styled(Image)`
  grid-column-start: 1;
  grid-row-start: 1;
  margin: 50px auto;
  width: 100%;
`;

const LogoImage = styled.div(
  ({ logoUrl }) => css`
    background: url(${logoUrl}) no-repeat center center;
    background-color: var(--color-bg-default);
    background-size: 40px auto;
    border-radius: var(--size-border-radius-md);
    grid-column-start: 1;
    grid-row-start: 1;
    height: 40px;
    margin: 105px auto 105px 97px;
    width: 40px;
  `
);

export {
  CardMessageEmptyStateWrapper,
  CardMessageWrapper,
  ExperienceBowImage,
  ExperienceCardImage,
  LogoImage
};
